import React from 'react';
import { connect } from 'react-redux';
import './SubPage.css';

const SubPage = props => (
  <div className={`sub-page ${props.fullscreen ? 'fullscreen' : ''}`}>
    {props.children}
  </div>
);

const mapStateToProps = state => ({
  fullscreen: state.ui.fullscreen,
});

export default connect(mapStateToProps)(SubPage);



// WEBPACK FOOTER //
// ./src/components/Shared/SubPage/SubPage.js